module.exports = __webpack_public_path__ + "static/sweet-866db42e3d0effa2305349d5af0ac2cc.svg";